<template>
  <b-container>
    <h3>Benutzer:</h3>
    <hr class="mt-4 mb-4">
    <table class="table borderless">
      <tr>
        <td><b>Name:</b></td>
        <td>{{ user.name }}</td>
      </tr>
      <tr>
        <td><b>Email:</b></td>
        <td>{{ user.email }}</td>
      </tr>

      <tr>
        <td>
          <b>Admin:</b>
        </td>
        <td>
          <b-form-checkbox v-model="user.admin" name="check-button" switch disabled/>
        </td>
      </tr>
      <tr>
        <td>
          <b>Artikel:</b>
        </td>
        <td>
          <b-form-checkbox v-model="user.articles" name="check-button" @change="prepareUser('articles', $event)" switch/>
        </td>
      </tr>
      <tr>
        <td>
          <b>Kalender:</b>
        </td>
        <td>
          <b-form-checkbox v-model="user.calendar" name="check-button" @change="prepareUser('calendar', $event)" switch/>
        </td>
      </tr>
      <tr>
        <td>
          <b>Termine:</b>
        </td>
        <td>
          <b-form-checkbox v-model="user.events" name="check-button" @change="prepareUser('events', $event)" switch/>
        </td>
      </tr>
      <tr>
        <td>
          <b>Aufbau & Inhalt:</b>
        </td>
        <td>
          <b-form-checkbox v-model="user.cms" name="check-button" @change="prepareUser('cms', $event)" switch/>
        </td>
      </tr>
      <tr>
        <td>
          <b>Abwesenheitserklärung:</b>
        </td>
        <td>
          <b-form-checkbox v-model="user.excuses" name="check-button"  @change="prepareUser('excuses', $event)" switch/>
        </td>
      </tr>
      <tr>
        <td>
          <b>Hinweise:</b>
        </td>
        <td>
          <b-form-checkbox v-model="user.warnings" name="check-button" @change="prepareUser('warnings', $event)" switch/>
        </td>
      </tr>
      <tr>
        <td>
          <b>Schnellzugriffe:</b>
        </td>
        <td>
          <b-form-checkbox v-model="user.quickaccess" name="check-button" @change="prepareUser('quickaccess', $event)" switch/>
        </td>
      </tr>
      <tr>
        <td>
          <b>Berechtigungen:</b>
        </td>
        <td>
          <b-form-checkbox v-model="user.permissions" name="check-button" @change="prepareUser('permissions', $event)" switch/>
        </td>
      </tr>

    </table>
  </b-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "UserEdit",
  data() {
    return {
      userId: parseInt(this.$route.params.userId)
    }
  },
  computed: {
    ...mapGetters([
      'getStoredUserById'
    ]),
    user() {
      return this.getStoredUserById(this.userId)
    }
  },
  methods: {
    ...mapActions([
      'getUser',
      'saveUser'
    ]),
    prepareUser(name, event,) {
      let user = {
        id: this.userId
      }
      user[name] = event
      this.saveUser(user)
    }
  },
  mounted() {
    this.getUser()
  }
}
</script>

<style scoped>
.borderless td, .borderless th {
  border: none;
}
</style>
